
import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
//import { useLogout } from './useLogout';
import { useSelector } from 'react-redux';


const useTag = () =>{
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    //const logout = useLogout();

    const token = useSelector((state)=>state.user.itoken);

    const HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;

    const dispatch = useDispatch();

    const getUserTags = async(onSuccess,onError,includeUserTags=false) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.get(
            `${HOST}/api/v2/userTags?page=0&pageSize=10&includeUserTags=${includeUserTags}&orderDir=DESC`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const getDoorTags = async(onSuccess,onError,includeSpecialTags=false) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.get(
            `${HOST}/api/v2/smartLockTags?page=0&pageSize=10&includeSpecialTags=${includeSpecialTags}&orderDir=DESC&orderBy=id`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const createDoorTag = async(tagData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.post(
            `${HOST}/api/v2/smartLockTags`,
            tagData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const createUserTag = async(tagData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.post(
            `${HOST}/api/v2/userTags`,
            tagData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const editDoorTag = async(tagDoorId,tagData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.put(
            `${HOST}/api/v2/smartLockTags/${tagDoorId}`,
            tagData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const editUserTag = async(userTagId,tagData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.put(
            `${HOST}/api/v2/userTags/${userTagId}`,
            tagData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const deleteDoorTag = async(tagDoorId,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.delete(
            `${HOST}/api/v2/smartLockTags/${tagDoorId}`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    const deleteUserTag = async(userTagId,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.delete(
            `${HOST}/api/v2/userTags/${userTagId}`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200 || response.status === 201){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }


    return {getUserTags, getDoorTags, createDoorTag, createUserTag, editDoorTag, editUserTag, deleteDoorTag, deleteUserTag, tagLoading:loading, tagError:error};
};

export default useTag;